import React, { useState, Component } from "react";
import ICONS from "../../../../icons-lib";
import Header from "../includes/header/header";
import Card from "../includes/card/card";
import "./dashboard.scss";

const Dashboard = () => {

  const [tab1Active, setTab1Active] = useState(true);
  const [tab2Active, setTab2Active] = useState(false);
  const [tab3Active, setTab3Active] = useState(false);

  const changeTab = (tabNumber) => {
    switch (tabNumber) {
      case 1:
        setTab1Active(true);
        setTab2Active(false);
        setTab3Active(false);
        break;

      case 2:
        setTab1Active(false);
        setTab2Active(true);
        setTab3Active(false);
        break;
      
      case 3:
        setTab1Active(false);
        setTab2Active(false);
        setTab3Active(true);
        break;
    
      default:
        break;
    }
  }


  const [modalCollectInfo, setModalCollectInfo] = useState(true);
  const [studentCategoryOpen, setStudentCategoryOpen] = useState(true);
  const [teacherCategoryOpen, setTeacherCategoryOpen] = useState(true);

  return (
    <>
      <Header />

      <div className={"modal collect-user-info-modal " + (modalCollectInfo ? "show" : "")}>
        <div className="modal-inner">
          <div className="title font-heading text-3xl mb-3"> Provide the following details to proceed </div>

          <div className="form-group grid text-left mb-6 error">
            <label htmlFor="" className="font-semibold">Gender</label>
            <select name="" id="" className="form-control p-4 border rounded-2xl">
              <option value="">Select your gender</option>
              <option value="">Male</option>
              <option value="">Female</option>
              <option value="">Other</option>
            </select>
            <div className="errorText">This field is required</div>
          </div>

          <div className="form-group grid text-left mb-6">
            <label htmlFor="" className="font-semibold">Grade level</label>
            <select name="" id="" className="form-control p-4 border rounded-2xl">
              <option value="">Select your grade level</option>
              <option value="">grade 1</option>
              <option value="">grade 2</option>
              <option value="">grade 3</option>
            </select>
          </div>

          <div className="form-group grid text-left mb-6 error">
            <label htmlFor="" className="font-semibold">Ethnicity</label>
            <input type="text" className="form-control p-4 border rounded-2xl" placeholder="Enter your ethnicity" />
            <div className="errorText">This field is required</div>
          </div>

          <div className="form-group grid text-left mb-6">
            <label htmlFor="" className="font-semibold">Course of study</label>
            <input type="text" className="form-control p-4 border rounded-2xl" placeholder="Enter your course of study" />
          </div>

          <div className="buttons">
            <div className="button fancy" onClick={(e) => setModalCollectInfo(false)}>
              <span>Submit</span>
              {ICONS.SVG_Arrow_curly}
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-page-wrapper bg-color_primary_light flex items-center justify-center mb-32">
        <div className="inner-wrapper container py-8">

          <div className="tabs grid grid-cols-2 my-10">
            <div
              className={"tab tab1 all-survey flex items-center justify-center opacity-50 cursor-pointer py-4 " + (tab1Active ? "active" : "")}
              onClick={(e) => changeTab(1)}
            >
              {ICONS.SVG_Bar_chart}
              <span className="text-size-heading-small font-heading ml-4">All survey</span>
            </div>
            <div
              className={"tab tab2 all-survey flex items-center justify-center opacity-50 cursor-pointer py-4 " + (tab2Active ? "active" : "")}
              onClick={(e) => changeTab(2)}
            >
              {ICONS.SVG_User}
              <span className="text-size-heading-small font-heading ml-4">In progress</span>
            </div>
          </div>



          <div className="tab-contents">
            <div className={"conten1 all-survey-content " + (tab1Active ? "" : "hidden")}>
              <div className={"survey-category mb-10 student-survey " + (studentCategoryOpen ? "open" : "")}>
                <div
                  className="content-title flex justify-between items-center p-5 mb-8 cursor-pointer duration-300 bg-secondary-light hover:bg-secondary-dark rounded-3xl"
                  onClick={(e)=>setStudentCategoryOpen(!studentCategoryOpen)}
                >
                  <span className="font-heading text-2xl flex items-center gap-3">{ICONS.SVG_student} Students survey</span>
                  <span className="icon">{ICONS.SVG_chevron_down}</span>
                </div>
                <div className="content-inner grid grid-cols-2 gap-16">
                  <Card style="1" />
                  <Card style="1" />
                  <Card style="1" />
                  <Card style="1" />
                  <Card style="1" />
                  <Card style="1" />
                  <Card style="1" />
                  <Card style="1" />
                </div>
              </div>



              <div className={"survey-category mb-10 teacher-survey " + (teacherCategoryOpen ? "open" : "")}>
                <div
                  className="content-title flex justify-between items-center p-5 mb-8 cursor-pointer duration-300 bg-secondary-light hover:bg-secondary-dark rounded-3xl"
                  onClick={(e)=>setTeacherCategoryOpen(!teacherCategoryOpen)}
                >
                  <span className="font-heading text-2xl flex items-center gap-3">{ICONS.SVG_teacher} Teacher survey</span>
                  <span className="icon">{ICONS.SVG_chevron_down}</span>
                </div>
                <div className="content-inner grid grid-cols-2 gap-16">
                  <Card style="2" />
                  <Card style="2" />
                  <Card style="2" />
                  <Card style="2" />
                  <Card style="2" />
                  <Card style="2" />
                  <Card style="2" />
                  <Card style="2" />
                </div>
              </div>
            </div>
            
            <div className={"conten2 inprogress-survey-content " + (tab2Active ? "" : "hidden")}>
              <div className="content-inner grid grid-cols-2 gap-16">
                <Card style="3" />
                <Card style="3" />
                <Card style="3" />
                <Card style="3" />
                <Card style="3" />
                <Card style="3" />
                <Card style="3" />
                <Card style="3" />
                <Card style="3" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Dashboard;
